import GTMDonationEvents from "./gtm-donation-events"
class DonationPayment {
  constructor() {
    let path = window.location.pathname.replace(/\/+$/, "")

    this.getTransactionUrl = path + "/getTransaction"
    this.state = {}

    this.initComponents()
  }

  initComponents() {
    this.paymentFrameWrapper = document.querySelector("#donation-payment")
    this.spinner = document.querySelector(".spinner-border")
    this.errorMessageWrapper = document.querySelector("[js-payment-error]")
  }

  /**
   * Check if payment has been successfully completed
   */
  getTransaction(transactionReference) {
    const formData = new FormData()
    formData.append("TransactionReference", transactionReference)

    // send request
    var xhr = new XMLHttpRequest()
    xhr.open("POST", this.getTransactionUrl)
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest")
    xhr.responseType = "json"
    xhr.onload = () => this.checkTransactionStatus(xhr.status, xhr.response)
    xhr.send(formData)
  }

  startTransaction(transactionReference, paymentUrl, amount, Office) {
    return new Promise((resolve, reject) => {
      GTMDonationEvents.ProceedToPayment(amount, Office)
      // store ref so we can reload the page & re-display a still pending payment
      window.localStorage.setItem("transactionReference", transactionReference)
      window.localStorage.setItem("paymentUrl", paymentUrl)

      this.paymentFrameWrapper.innerHTML = ""
      this.paymentFrame = this.createPaymentFrame(this.paymentFrameWrapper, paymentUrl)
      this.paymentFrame.classList.add("paystation-payment-frame")

      // ask our server when Payment record has completed
      this.pollTransactionDetails(transactionReference)

      this.onTransactionSuccess = resolve
      this.onTransactionFail = reject
    })
  }

  createPaymentFrame(parentElement, paymentUrl) {
    this.spinner.classList.add("d-none")

    let paymentFrame = document.createElement("iframe")

    const backgroundColour = "fff"
    paymentFrame.src = paymentUrl += "&b=" + backgroundColour
    parentElement.appendChild(paymentFrame)
    this.bindFrameLoadEvent(paymentFrame, this.onFrameLoaded.bind(this))
    return paymentFrame
  }

  // This is used to detect when the frame is redirected. If you are not using redirects then you wont need to use this.
  bindFrameLoadEvent(frame, onLoad) {
    if (navigator.userAgent.indexOf("MSIE") > -1 && !window.opera) {
      frame.addEventListener("readystatechange", function() {
        if (frame.readyState == "complete") {
          onLoad(frame)
        }
      })
    } else {
      frame.addEventListener("load", function() {
        onLoad(frame)
      })
    }
  }

  // This gets called whenever a new page is loaded in the iframe. This is only possible if you are using redirects.
  onFrameLoaded(iframe) {
    // Browsers shouldn't allow access to the content of an iframe unless it is from your own domain.
    // So, if we can access the content, then the user has been redirected back to your site from paystation.
    if (this.canAccessIFrame(iframe)) {
      // We have redirected back to our own site inside the iframe.
      // It is possible to grab some data from inside the frame, but it is better and often quicker to use polling to get this response as that data can be trusted.
      this.closePaymentFrame(iframe)
    }
  }

  // Most browsers do not allow manipulating the contents of an iframe if it is in a different domain.
  // This can be used to test if the client has been redirected back to your website after making the payment in paystation.
  canAccessIFrame(iframe) {
    let html = null
    try {
      let doc = iframe.contentDocument || iframe.contentWindow.document
      html = doc.body.innerHTML
    } catch (err) {
      // Expect exception: DOMException: Blocked a frame
    }
    return html !== null
  }

  closePaymentFrame(paymentFrame) {
    if (paymentFrame) {
      paymentFrame.parentNode.removeChild(paymentFrame)
    }
  }

  // Since we don't know when the transaction is complete we can use this to constantly check its status.
  pollTransactionDetails(transactionReference) {
    this.stopPolling()

    this.pollingInterval = window.setInterval(() => {
      this.getTransaction(transactionReference)
    }, 1337)
  }

  // This is only designed to poll for one transaction at a time.
  // It will need to be reworked if you want the user to be making multiple payments on the same screen.
  stopPolling() {
    if (this.pollingInterval) {
      window.clearInterval(this.pollingInterval)
    }
  }

  /**
   * This function will get a response every time we poll.
   * Most of these responses will get transaction details for an incomplete
   * transaction while the user is still entering their details in the iframe.
   */
  checkTransactionStatus(status, transaction) {
    // transaction is complete, stop polling

    if (transaction.hasError || transaction.isSuccessful) {
      this.stopPolling()
      this.onTransactionComplete(transaction)
    }

    // otherwise continue polling
  }

  // Remove the iframe and show a response to the user.
  onTransactionComplete(transaction) {
    // Clear local storage
    window.localStorage.removeItem("transactionReference")
    window.localStorage.removeItem("paymentUrl")

    // transaction failed
    if (transaction.hasError) {
      GTMDonationEvents.PaymentFailed("One-off")

      this.showError(transaction.errorMessage)
      this.onTransactionFail()
      return
    }

    // transaction success
    if (transaction.isSuccessful) {
      this.state.transactionError = false
      this.state.transactionSuccess = true

      // Clear local storage
      window.localStorage.clear()

      this.onTransactionSuccess(transaction.successUrl)
    }
  }

  showError(message) {
    this.errorMessageWrapper.classList.remove("d-none")
    this.errorMessageWrapper.querySelector("p[js-payment-error-message]").innerText = `${message}.`

    setTimeout(() => {
      this.errorMessageWrapper.classList.add("d-none")
    }, 5000)
  }

  hideError() {
    this.errorMessageWrapper.classList.add("d-none")
  }
}

export default function init() {
  if (document.querySelector("#donation-payment")) {
    return new DonationPayment()
  }
}
